import { API_BLOG_COMMENT_STORE } from '@/constant/apiRout';
import axios from '@/lib/axios';
import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { toast } from 'react-toastify';

interface BlogCommentsFormProps {
  blog_id: number;
}

interface CommentFormInputs {
  name: string;
  email: string;
  comment: string;
}

const BlogCommentsForm: React.FC<BlogCommentsFormProps> = ({ blog_id }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<CommentFormInputs>();

  const onSubmit: SubmitHandler<CommentFormInputs> = async (data) => {
    try {
      const payload = {
        ...data,
        blog_id,
      };

      const response = await axios.post(API_BLOG_COMMENT_STORE, payload);
      if (response.data.result) {
        toast.success(response.data.message || '✅ Comment submitted:');
      } else {
        toast.error(response.data.message || '❌ Error submitting comment:');
      }

      reset();
    } catch (error) {
      toast.error('❌ Error submitting comment:');
    }
  };

  return (
    <div
      className="blog-details__commentform"
      data-aos="fade-up"
      data-aos-duration={1000}
    >
      <div className="sidebar">
        <div className="sidebar__commentform" id="post">
          <div className="sidebar__head">
            <h3>Leave A Comment</h3>
          </div>
          <div className="sidebar__commentform-body pt-25">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row g-4">
                {/* Name */}
                <div className="col-md-6">
                  <div>
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="name"
                      placeholder="Full Name"
                      {...register('name', { required: 'Name is required' })}
                    />
                    {errors.name && (
                      <p className="text-danger">{errors.name.message}</p>
                    )}
                  </div>
                </div>

                {/* Email */}
                <div className="col-md-6">
                  <div>
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      className="form-control"
                      type="email"
                      id="email"
                      placeholder="Email here"
                      {...register('email', {
                        required: 'Email is required',
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: 'Invalid email format',
                        },
                      })}
                    />
                    {errors.email && (
                      <p className="text-danger">{errors.email.message}</p>
                    )}
                  </div>
                </div>

                {/* Comment */}
                <div className="col-md-12">
                  <div>
                    <label htmlFor="comment" className="form-label">
                      Message
                    </label>
                    <textarea
                      cols={30}
                      rows={5}
                      className="form-control"
                      id="comment"
                      placeholder="Enter Your Message"
                      {...register('comment', {
                        required: 'Comment is required',
                      })}
                    />
                    {errors.comment && (
                      <p className="text-danger">{errors.comment.message}</p>
                    )}
                  </div>
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="trk-btn trk-btn--border trk-btn--primary mt-4"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCommentsForm;
